<wsd-extended-card
  [loading]="!(safeFromHarm$ | async)"
  [title]="'DATA_PORTAL.SAFE_FROM_HARM.TITLE' | translate"
  [redirectTo]="['/organizations', organizationId, 'modify', 'reporting']">

  <div class="text-left p-grid" *ngIf="safeFromHarm$ | async as data">

    <div class="p-col">
      <ng-container *ngIf="data.safeFromHarmPersons && data.safeFromHarmPersons.length > 0; else noPerson">
        <label
          pTooltip=" {{ 'DATA_PORTAL.SAFE_FROM_HARM.TOOLTIP' | translate }}">
          {{ 'DATA_PORTAL.SAFE_FROM_HARM.CONTACT_PERSON' | translate }}
        </label>

        <div *ngFor="let person of data.safeFromHarmPersons" class="m-b-15">
          <p class="m-b-0">{{ person.firstName }} {{ person.lastName }}</p>
          <a class="m-b-0" href="mailto:{{ person.email }}">{{ person.email }}</a>
        </div>
      </ng-container>
      <ng-container *ngIf="data.sfhAssessmentDate; else noDate">
        <ng-container *gsShowIfHasPermission="['ORGANIZATION_SAFE_FROM_HARM_ASSESSMENT_READ']">
          <i class="fa fa-check-circle text-success fa-lg"></i>
          {{ 'DATA_PORTAL.SAFE_FROM_HARM.ASSESSED_ON' | translate }} {{data.sfhAssessmentDate |  date: 'dd MMMM yyyy'}}
        </ng-container>
      </ng-container>
    </div>

    <div class="p-col">
      <wsd-report class="m-b-15"
                  *gsShowIfHasPermission="['ORGANIZATION_SAFE_FROM_HARM_POLICY_READ']"
                  [title]="'DATA_PORTAL.SAFE_FROM_HARM.POLICY' | translate"
                  [organizationId]="organizationId"
                  [fileId]="data.sfhPolicyFileId"
                  [date]="data.sfhPolicyLastUpdateDate"
                  [year]="data.sfhPolicyYear">
      </wsd-report>

      <wsd-report class="m-b-0"
                  *gsShowIfHasPermission="['ORGANIZATION_SAFE_FROM_HARM_REPORTING_READ']"
                  [title]="'DATA_PORTAL.SAFE_FROM_HARM.REPORT' | translate"
                  [organizationId]="organizationId"
                  [fileId]="data.sfhReportFileId"
                  [date]="data.sfhReportLastUpdateDate"
                  [year]="data.sfhReportYear">
      </wsd-report>
    </div>

    <ng-template #noPerson>
      <div class="m-b-15">
        <i class="fa fa-times-circle fa-lg text-danger" pTooltip=" {{ 'DATA_PORTAL.SAFE_FROM_HARM.TOOLTIP' | translate }}"></i>
        {{ 'DATA_PORTAL.SAFE_FROM_HARM.NO_CONTACT_PERSON' | translate }}
      </div>
    </ng-template>

    <ng-template #noDate>
      <div>
        <i class="fa fa-times-circle fa-lg text-danger"></i>
        {{ 'DATA_PORTAL.SAFE_FROM_HARM.NOT_ASSESSED' | translate }}
      </div>
    </ng-template>

  </div>


</wsd-extended-card>
